export const BuildLogSummaryQueryKeys = {
  all: () => ['build_log_summary'],
  details: () => [...BuildLogSummaryQueryKeys.all(), 'details'],
  detail: (buildSlug: string) => [...BuildLogSummaryQueryKeys.details(), buildSlug],
};

export const StepLogQueryKeys = {
  all: () => ['step_logs'],
  lists: () => [...StepLogQueryKeys.all(), 'lists'],
  list: (appSlug: string, buildSlug: string) => [...StepLogQueryKeys.lists(), { appSlug, buildSlug }],
  details: () => [...StepLogQueryKeys.all(), 'details'],
  detail: (logUUID: string) => [
    ...StepLogQueryKeys.details(),
    {
      logUUID,
    },
  ],
  archivedDetails: () => [...StepLogQueryKeys.details(), 'archived'],
  archivedDetail: (logUUID: string) => [...StepLogQueryKeys.archivedDetails(), { logUUID }],
};
